import styled from 'styled-components';

export const EllipsisOne = styled.span`
  animation: ellipsis-one 1.4s infinite;

  @keyframes ellipsis-one {
    0% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const EllipsisTwo = styled.span`
  animation: ellipsis-two 1.4s infinite;

  @keyframes ellipsis-two {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const EllipsisThree = styled.span`
  animation: ellipsis-three 1.4s infinite;

  @keyframes ellipsis-three {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
